import { useSelector } from 'react-redux';

import { createSelector } from 'reselect';

import { selectAuth } from '@lib/selectors';

const selectAuthWidgetUser = createSelector(selectAuth, (auth) => auth?.widgetUser);

export default function useCurrentWidgetUser() {
  return useSelector(selectAuthWidgetUser);
}
